import { Component, Input, OnDestroy } from '@angular/core';

import { OnInit } from '@angular/core';

import { RecallReportService } from '../../services/recall-report.services';
import { MatDialog } from '@angular/material';
import { AddBatchDialogComponent } from "../add-batch/add-batch-dialog.component";
import { EventBusService } from '../../services/event-bus.service';
import { GlobalCfgService } from 'src/services/globalcfg.service';

@Component({
  selector: 'rm-recall-report',
  templateUrl: './recall-report.component.html',
  styleUrls: ['./recall-report.component.css']
})
export class RecallReportComponent implements OnInit, OnDestroy {

  @Input()
  productId: string;

  @Input()
  gcp: string;

  searchTxt: string = '';
  selectedProduct: string = 'all';
  selectedLocation: string = 'all';
  searchByBatch: boolean = false;

  //Used for pagination
  bookmark: string = "";
  totalCount: number = 0;
  pageSize: number = 5;
  skip: number = 0;
  expiryData: any[] = [];
  columns: any[] = [
    { name: 'batchNo', displayName: 'Batch No.', actionable: true, tip: 'View Batch Detail' },
    { name: 'recallDt', displayName: 'Recalled On', type: 'date', format: 'DD/MM/YYYY' },
    { name: 'recalledDescription', displayName: 'Recall Reason' },
    { name: 'gtinsImpactedCnt', displayName: '# of GTINs Impacted' },
    { name: 'instancesImpactedCnt', displayName: '# of Instances Impacted' },
    { name: 'actions', displayName: '' }
  ];
  products: any[] = [];
  locations: any[] = [];
  subscriptions: any[] = [];
  bookmarks: any[] = [];
  labels: any;

  constructor(
    private recallReportService: RecallReportService,
    private ebService: EventBusService,
    private dialog: MatDialog,
    private globalCfgService: GlobalCfgService
  ) { }

  ngOnInit() {
    this.subscriptions.push(this.ebService.productsListValue$.subscribe(
      (list) => this.products = list
    ));
    this.subscriptions.push(this.ebService.locationsListValue$.subscribe(
      (list) => this.locations = list
    ));

    if (!this.gcp) {
      this.gcp = this.globalCfgService.getGcp();
      this.labels = this.globalCfgService.getSettingValue('labels');
    }
    this.labels = this.globalCfgService.getSettingValue('labels');
    
    this.subscriptions.push(this.ebService.particpantSelectionFetchedValue$.subscribe(
      (gcp) => {
        this.gcp = gcp;
        this.load();
      }
    ));

    this.load();
  }

  load() {
    this.ebService.loadProductsList(this.gcp);
    this.ebService.loadLocationsList(this.gcp);
    this.loadRecallData();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  loadRecallData(page?) {
    if (!this.gcp) {
      this.gcp = this.globalCfgService.getGcp();
    }
    var obj = {};

    if (this.gcp) {
      obj['gcp'] = this.gcp;
    }

    if (this.productId) {
      obj['gtin'] = this.productId;
      this.selectedProduct = this.productId;
    }

    if (this.selectedLocation != 'all') {
      obj['gln'] = this.selectedLocation
    }

    if (this.selectedProduct != 'all') {
      obj['gtin'] = this.selectedProduct
    }

    if (this.searchByBatch) {
      obj['batch'] = this.searchTxt;
    }

    obj['pageSize'] = (page && page.pageSize) || this.pageSize;
    if (page) {
      this.skip = page.pageIndex * this.pageSize;
      obj['skip'] = this.skip;
    } else if (page === undefined) {
      obj['skip'] = this.skip;
    }

    this.recallReportService.expiryReport(obj).subscribe(
      (response) => {
        if (page && page.pageIndex) {
          this.bookmarks[page.pageIndex + 1] = response['metadata'].bookmark;
        } else {
          this.bookmarks[1] = response['metadata'].bookmark;
        }
        this.totalCount = response['metadata'].totalCount;
        this.expiryData = Object(response['result']);
      });
  }

  setSearchByBatch(status) {
    if (!status && this.searchTxt.length > 0) {
      return;
    }
    this.searchByBatch = status;
  }

  clear() {
    this.searchTxt = '';
    this.searchByBatch = false;
  }

  onActionableClicked(e) {
    console.log('onActionableClicked:', e);

    var rec = e.record;
    switch (e.actionName) {
      case 'batchNo':
        this.dialog.open(AddBatchDialogComponent, {
          width: "2400px",
          data: {
            rec: rec,
            title: 'Batch Detail'
          }
        });
        break;
      default:
        console.log('Unhandled actionable: ', e.actionName);
    }

  }

  applyFilter() {
    this.skip = 0;
    this.loadRecallData();
  }

  onPageChanged(page) {
    this.pageSize = page.pageSize;
    this.loadRecallData(page);
  }
}